<template>
<div class="chapter">
<div class="inner_page">
<h1 class="h1">CONTENTS</h1>
<nav epub:type="toc" id="toc">
<ol class="tocol">
<li class="table-of-content">
<a href="#/0_chapter301tuskdescending">CHAPTER 301 - TUSK DESCENDING</a>
</li>
<li class="table-of-content">
<a href="#/1_chapter302savethepoorofasmalltown">CHAPTER 302 - SAVE THE POOR OF A SMALL TOWN</a>
</li>
<li class="table-of-content">
<a href="#/2_chapter303rallying">CHAPTER 303 - RALLYING</a>
</li>
<li class="table-of-content">
<a href="#/3_chapter304inthenameoftheqinemperor">CHAPTER 304 - IN THE NAME OF THE QIN EMPEROR</a>
</li>
<li class="table-of-content">
<a href="#/4_chapter305mysteriousman">CHAPTER 305 - MYSTERIOUS MAN</a>
</li>
<li class="table-of-content">
<a href="#/5_chapter306crosscounting">CHAPTER 306 - CROSS COUNTING</a>
</li>
<li class="table-of-content">
<a href="#/6_chapter307yangtiansdanger">CHAPTER 307 - YANG TIAN'S DANGER</a>
</li>
<li class="table-of-content">
<a href="#/7_chapter308mysteriousinjection">CHAPTER 308 - MYSTERIOUS INJECTION</a>
</li>
<li class="table-of-content">
<span href="#/8_chapter309enigmatic" title="Link target outside of Sample">CHAPTER 309 - ENIGMATIC</span>
</li>
<li class="table-of-content">
<span href="#/9_chapter310virusreappearance" title="Link target outside of Sample">CHAPTER 310 - VIRUS REAPPEARANCE</span>
</li>
<li class="table-of-content">
<span href="#/10_chapter311novelvirus" title="Link target outside of Sample">CHAPTER 311 - NOVEL VIRUS</span>
</li>
<li class="table-of-content">
<span href="#/11_chapter312whostheboss" title="Link target outside of Sample">CHAPTER 312 - WHO'S THE BOSS</span>
</li>
<li class="table-of-content">
<span href="#/12_chapter313airborneisland" title="Link target outside of Sample">CHAPTER 313 - AIRBORNE ISLAND</span>
</li>
<li class="table-of-content">
<span href="#/13_chapter314islandcrisis" title="Link target outside of Sample">CHAPTER 314 - ISLAND CRISIS</span>
</li>
<li class="table-of-content">
<span href="#/14_chapter315strangestonehouse" title="Link target outside of Sample">CHAPTER 315 - STRANGE STONE HOUSE</span>
</li>
<li class="table-of-content">
<span href="#/15_chapter316themonsterappearsagain" title="Link target outside of Sample">CHAPTER 316 - THE MONSTER APPEARS AGAIN</span>
</li>
<li class="table-of-content">
<span href="#/16_chapter317overon" title="Link target outside of Sample">CHAPTER 317 - OVER ON</span>
</li>
<li class="table-of-content">
<span href="#/17_chapter318bringhimback" title="Link target outside of Sample">CHAPTER 318 - BRING HIM BACK</span>
</li>
<li class="table-of-content">
<span href="#/18_chapter319nationalrescue" title="Link target outside of Sample">CHAPTER 319 - NATIONAL RESCUE</span>
</li>
<li class="table-of-content">
<span href="#/19_chapter320receptionathome" title="Link target outside of Sample">CHAPTER 320 - RECEPTION AT HOME</span>
</li>
<li class="table-of-content">
<span href="#/20_chapter321banquet" title="Link target outside of Sample">CHAPTER 321 - BANQUET</span>
</li>
<li class="table-of-content">
<span href="#/21_chapter322provokebythesecurityguard" title="Link target outside of Sample">CHAPTER 322 - PROVOKE BY THE SECURITY GUARD</span>
</li>
<li class="table-of-content">
<span href="#/22_chapter323kankaisattitude" title="Link target outside of Sample">CHAPTER 323 - KANKAI'S ATTITUDE</span>
</li>
<li class="table-of-content">
<span href="#/23_chapter324varioustaunts" title="Link target outside of Sample">CHAPTER 324 - VARIOUS TAUNTS</span>
</li>
<li class="table-of-content">
<span href="#/24_chapter325kankaisthoughts" title="Link target outside of Sample">CHAPTER 325 - KANKAI'S THOUGHTS</span>
</li>
<li class="table-of-content">
<span href="#/25_chapter326emotionalconfession" title="Link target outside of Sample">CHAPTER 326 - EMOTIONAL CONFESSION</span>
</li>
<li class="table-of-content">
<span href="#/26_chapter327banquetassassination" title="Link target outside of Sample">CHAPTER 327 - BANQUET ASSASSINATION</span>
</li>
<li class="table-of-content">
<span href="#/27_chapter328searchforghosts" title="Link target outside of Sample">CHAPTER 328 - SEARCH FOR GHOSTS</span>
</li>
<li class="table-of-content">
<span href="#/28_chapter329evokeinnerghosts" title="Link target outside of Sample">CHAPTER 329 - EVOKE INNER GHOSTS</span>
</li>
<li class="table-of-content">
<span href="#/29_chapter330mercenaryforbiddenarea" title="Link target outside of Sample">CHAPTER 330 - MERCENARY FORBIDDEN AREA</span>
</li>
<li class="table-of-content">
<span href="#/30_chapter331pretendtobecaptured" title="Link target outside of Sample">CHAPTER 331 - PRETEND TO BE CAPTURED</span>
</li>
<li class="table-of-content">
<span href="#/31_chapter332theseverityofdespair" title="Link target outside of Sample">CHAPTER 332 - THE SEVERITY OF DESPAIR</span>
</li>
<li class="table-of-content">
<span href="#/32_chapter333totaldespair" title="Link target outside of Sample">CHAPTER 333 - TOTAL DESPAIR</span>
</li>
<li class="table-of-content">
<span href="#/33_chapter334thefinalpathofarigidwidth" title="Link target outside of Sample">CHAPTER 334 - THE FINAL PATH OF A RIGID WIDTH</span>
</li>
<li class="table-of-content">
<span href="#/34_chapter335eerieinsect" title="Link target outside of Sample">CHAPTER 335 - EERIE INSECT</span>
</li>
<li class="table-of-content">
<span href="#/35_chapter336tennames" title="Link target outside of Sample">CHAPTER 336 - TEN NAMES</span>
</li>
<li class="table-of-content">
<span href="#/36_chapter337tracing" title="Link target outside of Sample">CHAPTER 337 - TRACING</span>
</li>
<li class="table-of-content">
<span href="#/37_chapter338backtotheriver" title="Link target outside of Sample">CHAPTER 338 - BACK TO THE RIVER</span>
</li>
<li class="table-of-content">
<span href="#/38_chapter339misunderstandingconfessions" title="Link target outside of Sample">CHAPTER 339 - MISUNDERSTANDING CONFESSIONS</span>
</li>
<li class="table-of-content">
<span href="#/39_chapter340darksubstance" title="Link target outside of Sample">CHAPTER 340 - DARK SUBSTANCE</span>
</li>
<li class="table-of-content">
<span href="#/40_chapter341webrokeup" title="Link target outside of Sample">CHAPTER 341 - WE BROKE UP</span>
</li>
<li class="table-of-content">
<span href="#/41_chapter342devilisland" title="Link target outside of Sample">CHAPTER 342 - DEVIL ISLAND</span>
</li>
<li class="table-of-content">
<span href="#/42_chapter343hecame" title="Link target outside of Sample">CHAPTER 343 - HE CAME</span>
</li>
<li class="table-of-content">
<span href="#/43_chapter344bloodyslaughter" title="Link target outside of Sample">CHAPTER 344 - BLOODY SLAUGHTER</span>
</li>
<li class="table-of-content">
<span href="#/44_chapter345adragonsinversescaletouchdying" title="Link target outside of Sample">CHAPTER 345 - A DRAGON'S INVERSE SCALE TOUCH DYING</span>
</li>
<li class="table-of-content">
<span href="#/45_chapter346safereturn" title="Link target outside of Sample">CHAPTER 346 - SAFE RETURN</span>
</li>
<li class="table-of-content">
<span href="#/46_chapter347betweenthreepeople" title="Link target outside of Sample">CHAPTER 347 - BETWEEN THREE PEOPLE</span>
</li>
<li class="table-of-content">
<span href="#/47_chapter348acontestacrosstheair" title="Link target outside of Sample">CHAPTER 348 - A CONTEST ACROSS THE AIR</span>
</li>
<li class="table-of-content">
<span href="#/48_chapter349messagefromyangtian" title="Link target outside of Sample">CHAPTER 349 - MESSAGE FROM YANG TIAN</span>
</li>
<li class="table-of-content">
<span href="#/49_chapter350fieldgap" title="Link target outside of Sample">CHAPTER 350 - FIELD GAP</span>
</li>
<li class="table-of-content">
<span href="#/50_chapter351mysterious" title="Link target outside of Sample">CHAPTER 351 - MYSTERIOUS</span>
</li>
<li class="table-of-content">
<span href="#/51_chapter352capturetask" title="Link target outside of Sample">CHAPTER 352 - CAPTURE TASK</span>
</li>
<li class="table-of-content">
<span href="#/52_chapter353socalledimmortality" title="Link target outside of Sample">CHAPTER 353 - SO-CALLED IMMORTALITY</span>
</li>
<li class="table-of-content">
<span href="#/53_chapter354mysteriousland" title="Link target outside of Sample">CHAPTER 354 - MYSTERIOUS LAND</span>
</li>
<li class="table-of-content">
<span href="#/54_chapter355eastafricagreatriftvalley" title="Link target outside of Sample">CHAPTER 355 - EAST AFRICA GREAT RIFT VALLEY</span>
</li>
<li class="table-of-content">
<span href="#/55_chapter356ninedeadandonealive" title="Link target outside of Sample">CHAPTER 356 - NINE DEAD AND ONE ALIVE</span>
</li>
<li class="table-of-content">
<span href="#/56_chapter357rootlesswater" title="Link target outside of Sample">CHAPTER 357 - ROOTLESS WATER</span>
</li>
<li class="table-of-content">
<span href="#/57_chapter358liwusesrequest" title="Link target outside of Sample">CHAPTER 358 - LI WU SE'S REQUEST</span>
</li>
<li class="table-of-content">
<span href="#/58_chapter359theenmitybetweentheexterminationofonesclanandtheexterminationofanotherwasirreconcilable" title="Link target outside of Sample">CHAPTER 359 - THE ENMITY BETWEEN THE EXTERMINATION OF ONE'S CLAN AND THE EXTERMINATION OF ANOTHER WAS IRRECONCILABLE</span>
</li>
<li class="table-of-content">
<span href="#/59_chapter360costofabrokenarm" title="Link target outside of Sample">CHAPTER 360 - COST OF A BROKEN ARM</span>
</li>
<li class="table-of-content">
<span href="#/60_chapter361parsonconsortium" title="Link target outside of Sample">CHAPTER 361 - PARSON CONSORTIUM</span>
</li>
<li class="table-of-content">
<span href="#/61_chapter362qinchuansheart" title="Link target outside of Sample">CHAPTER 362 - QIN CHUAN'S HEART</span>
</li>
<li class="table-of-content">
<span href="#/62_chapter363oneparentsquare" title="Link target outside of Sample">CHAPTER 363 - ONE-PARENT SQUARE</span>
</li>
<li class="table-of-content">
<span href="#/63_chapter364thexuefamilyscrisis" title="Link target outside of Sample">CHAPTER 364 - THE XUE FAMILY'S CRISIS</span>
</li>
<li class="table-of-content">
<span href="#/64_chapter365xuefamilysattitude" title="Link target outside of Sample">CHAPTER 365 - XUE FAMILY'S ATTITUDE</span>
</li>
<li class="table-of-content">
<span href="#/65_chapter366xuefamilysrequest" title="Link target outside of Sample">CHAPTER 366 - XUE FAMILY'S REQUEST</span>
</li>
<li class="table-of-content">
<span href="#/66_chapter36710billion" title="Link target outside of Sample">CHAPTER 367 - 10 BILLION</span>
</li>
<li class="table-of-content">
<span href="#/67_chapter368astrangelittletown" title="Link target outside of Sample">CHAPTER 368 - A STRANGE LITTLE TOWN</span>
</li>
<li class="table-of-content">
<span href="#/68_chapter369mutant" title="Link target outside of Sample">CHAPTER 369 - MUTANT</span>
</li>
<li class="table-of-content">
<span href="#/69_chapter370deepinmine" title="Link target outside of Sample">CHAPTER 370 - DEEP IN MINE</span>
</li>
<li class="table-of-content">
<span href="#/70_chapter371threesecondmiracle" title="Link target outside of Sample">CHAPTER 371 - THREE-SECOND MIRACLE</span>
</li>
<li class="table-of-content">
<span href="#/71_chapter372killing" title="Link target outside of Sample">CHAPTER 372 - KILLING</span>
</li>
<li class="table-of-content">
<span href="#/72_chapter373rescuehostages" title="Link target outside of Sample">CHAPTER 373 - RESCUE HOSTAGES</span>
</li>
<li class="table-of-content">
<span href="#/73_chapter374sonicattacktothewest" title="Link target outside of Sample">CHAPTER 374 - SONIC ATTACK TO THE WEST</span>
</li>
<li class="table-of-content">
<span href="#/74_chapter375disguise" title="Link target outside of Sample">CHAPTER 375 - DISGUISE</span>
</li>
<li class="table-of-content">
<span href="#/75_chapter376falselytrue" title="Link target outside of Sample">CHAPTER 376 - FALSELY TRUE</span>
</li>
<li class="table-of-content">
<span href="#/76_chapter377deliberateprobing" title="Link target outside of Sample">CHAPTER 377 - DELIBERATE PROBING</span>
</li>
<li class="table-of-content">
<span href="#/77_chapter378secretbase" title="Link target outside of Sample">CHAPTER 378 - SECRET BASE</span>
</li>
<li class="table-of-content">
<span href="#/78_chapter379thesecretofthebase" title="Link target outside of Sample">CHAPTER 379 - THE SECRET OF THE BASE</span>
</li>
<li class="table-of-content">
<span href="#/79_chapter380atestoffalsevulgarity" title="Link target outside of Sample">CHAPTER 380 - A TEST OF FALSE VULGARITY</span>
</li>
<li class="table-of-content">
<span href="#/80_chapter381upliftspeech" title="Link target outside of Sample">CHAPTER 381 - UPLIFT SPEECH</span>
</li>
<li class="table-of-content">
<span href="#/81_chapter382huaroudanger" title="Link target outside of Sample">CHAPTER 382 - HUA ROU DANGER</span>
</li>
<li class="table-of-content">
<span href="#/82_chapter383sneakingin" title="Link target outside of Sample">CHAPTER 383 - SNEAKING IN</span>
</li>
<li class="table-of-content">
<span href="#/83_chapter384crazyside" title="Link target outside of Sample">CHAPTER 384 - CRAZY SIDE</span>
</li>
<li class="table-of-content">
<span href="#/84_chapter385theapocalypseiscoming" title="Link target outside of Sample">CHAPTER 385 - THE APOCALYPSE IS COMING</span>
</li>
<li class="table-of-content">
<span href="#/85_chapter386past" title="Link target outside of Sample">CHAPTER 386 - PAST</span>
</li>
<li class="table-of-content">
<span href="#/86_chapter387roleofthebody" title="Link target outside of Sample">CHAPTER 387 - ROLE OF THE BODY</span>
</li>
<li class="table-of-content">
<span href="#/87_chapter388oneyearlater" title="Link target outside of Sample">CHAPTER 388 - ONE YEAR LATER</span>
</li>
<li class="table-of-content">
<span href="#/88_chapter389thedanceoffireandthegoldenchild" title="Link target outside of Sample">CHAPTER 389 - THE DANCE OF FIRE AND THE GOLDEN CHILD</span>
</li>
<li class="table-of-content">
<span href="#/89_chapter390geniusofvariousraces" title="Link target outside of Sample">CHAPTER 390 - GENIUS OF VARIOUS RACES</span>
</li>
<li class="table-of-content">
<span href="#/90_chapter391sunchouscheapshot" title="Link target outside of Sample">CHAPTER 391 - SUN CHOU'S CHEAP SHOT</span>
</li>
<li class="table-of-content">
<span href="#/91_chapter392darkalliance" title="Link target outside of Sample">CHAPTER 392 - DARK ALLIANCE</span>
</li>
<li class="table-of-content">
<span href="#/92_chapter393snowstormskycurtain" title="Link target outside of Sample">CHAPTER 393 - SNOWSTORM SKY CURTAIN</span>
</li>
<li class="table-of-content">
<span href="#/93_chapter394youaresuchapervert" title="Link target outside of Sample">CHAPTER 394 - YOU ARE SUCH A PERVERT</span>
</li>
<li class="table-of-content">
<span href="#/94_chapter395crazyastheqinemperor" title="Link target outside of Sample">CHAPTER 395 - CRAZY AS THE QIN EMPEROR</span>
</li>
<li class="table-of-content">
<span href="#/95_chapter396youdontknowhim" title="Link target outside of Sample">CHAPTER 396 - YOU DON'T KNOW HIM</span>
</li>
<li class="table-of-content">
<span href="#/96_chapter397triplekillingofwoodrace" title="Link target outside of Sample">CHAPTER 397 - TRIPLE KILLING OF WOOD RACE</span>
</li>
<li class="table-of-content">
<span href="#/97_chapter398rainbowscreen" title="Link target outside of Sample">CHAPTER 398 - RAINBOW SCREEN</span>
</li>
<li class="table-of-content">
<span href="#/98_chapter399superiorandinferiorjudgement" title="Link target outside of Sample">CHAPTER 399 - SUPERIOR AND INFERIOR JUDGEMENT</span>
</li>
<li class="table-of-content">
<span href="#/99_chapter400spiritcrystalthesizeofahead" title="Link target outside of Sample">CHAPTER 400 - SPIRIT CRYSTAL THE SIZE OF A HEAD</span>
</li>
</ol>
</nav>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?2e9d0f22